<template>
<div class="sug-select-user">
  <popup
    ref="popup"
    class="full-page"
    fullScreen
    :visible="true">
    <!-- 搜索框 -->
    <div class="search-bar">
      <div class="search-input">
        <span class="icon-outlined_back_android cancel-btn" @click="hide"></span>
        <div class="search-input-box">
          <rich-input-box
            v-model="keyword"
            :placeholder="gettext('请输入')"
            clearable
          >
            <i class="crm-outline_search richic-search" slot="prepend"></i>
          </rich-input-box>
        </div>
      </div>
      <!-- <span class="cancel-btn" @click="hide">{{gettext('取消')}}</span> -->
    </div>
    <!-- 搜索历史 -->
    <div class="search-history">
      <div class="history-title" v-if="!keyword && historyItems && historyItems.length">
        <span class="search-history-title">{{$t('Gattaran_Collection__cRDE' /**最近搜索 */)}}</span>
        <i class="crm-Icon_delete" @click="clearHistoryHandler"></i>
      </div>
      <div class="search-list-wrap" v-if="!keyword && historyItems && historyItems.length">
        <div class="search-list-inner-wrap">
          <ul class="search-list">
            <li
              class="search-list-history-item"
              v-for="(item, index) in historyItems"
              :key="index"
              @click="clickHistoryItem(item)"
            >
              <rich-cell
                :key="index"
                :title="item.username"
              >
                <!-- <i
                  class="richic-close remove-btn"
                  @click.stop="removeHistoryItem(item.index)"
                /> -->
              </rich-cell>
            </li>
          </ul>
        </div>
      </div>
      <!-- 推荐 -->
      <div class="search-recommended" v-if="!keyword && recommenItems && recommenItems.length">
        <div class="recommended-title">
          <span class="search-recommended-title">{{$t('Gattaran_Collection__YHYF' /**推荐 */)}}</span>
        </div>
        <div class="search-list-wrap">
          <div class="search-list-inner-wrap">
            <ul class="search-list">
              <li
                class="search-list-recommended-item"
                v-for="(item, index) in recommenItems"
                :key="index"
                @click="clickHistoryItem(item)"
              >
                <rich-cell
                  :key="index"
                  :title="item.username"
                >
                  <!-- <i
                    class="richic-close remove-btn"
                    @click.stop="removeHistoryItem(item.index)"
                  /> -->
                </rich-cell>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- 搜索结果 -->
    <div class="search-result" v-show="keyword">
      <rich-loading v-show="loading"></rich-loading>
      <div class="search-scroll-wrap" v-if="!loading">
        <rich-result-page
          type="empty"
          v-show="result.length === 0"
        />
        <rich-scroll ref="searchScroll" v-if="result.length > 0">
          <div class="search-list-inner-wrap">
            <ul class="search-list">
              <li
                class="search-list-item"
                v-for="(item, index) in result"
                :key="index">
                <rich-cell
                  :key="index"
                  :title="item.username + ' (' + item.fullName +  ')'"
                  @click="clickSearchItem(item)"
                />
              </li>
              <slot></slot>
            </ul>
          </div>
        </rich-scroll>
      </div>
    </div>
  </popup>
</div>
</template>
<script>
import storage from 'didi-store'
import popup from './Popup'
import { request } from '@/common/utils/request'
import { debounce } from '@/common/utils/util'
import copySymbols from 'lodash/_copySymbols'
const HISTORY_KEY = 'BD_SHOP_DETAIL_HISTORY'
export default {
  name: 'SugSelUser',
  components: {
    popup
  },
  data () {
    return {
      isFirstSearch: true,
      loading: false,
      keyword: '',
      result: [],
      historyItems: [],
      loaded: false,
      activeIndex: -1,
      recommenItems: []
    }
  },
  watch: {
    keyword (nVal) {
      if (nVal) {
        this.loading = true
        this.searchHandler(nVal)
      }
    }
  },
  mounted () {
    this.historyItems = this.getHistoryItems()
    this.getBdSuperiorChain()
  },
  methods: {
    show () {
      this.$refs.popup.show()
    },
    hide () {
      this.$refs.popup.hide()
      setTimeout(() => {
        this.remove()
      }, 200)
    },
    searchHandler: debounce(async function (keyWord) {
      request.get({
        url: 'feidian.visit.getUserSug',
        params: {
          keyWord: keyWord
        }
      }).then(res => {
        this.result = res.data || []
      }).finally(() => {
        this.loading = false
      })
    }, 800),
    getBdSuperiorChain () {
      this.loading = true
      request.get({
        url: ' feidian.visit.getAccompanyBDSuperiorChain',
        params: {
          levelNum: 2
        }
      }).then(res => {
        this.loading = false
        this.recommenItems = res.data.list || []
      }).finally(() => {
        this.loading = false
      })
    },
    clickSearchItem (item) {
      this.$emit('select', item.username)
      this.keyword = ''
      this.setHistoryItems(item)
    },
    clearHistoryHandler () {
      // 二次确认
      this.$createDialog({
        type: 'confirm',
        icon: 'richic-important',
        title: this.gettext('确认要清空搜索记录吗？'),
        onConfirm: () => {
          this.historyItems = []
          storage.remove(HISTORY_KEY)
        },
        onCancel: () => {}
      }).show()
    },
    clickHistoryItem (item) {
      this.$emit('select', item.username)
      this.keyword = ''
    },
    setHistoryItems (item) {
      let storedItems = storage.get(HISTORY_KEY)
      if (storedItems) {
        const exist = storedItems.find(shop => shop.username === item.username)
        if (!exist) {
          storedItems.push(item)
        }
      } else {
        storedItems = [item]
      }
      storage.set(HISTORY_KEY, storedItems)
    },
    getHistoryItems () {
      let history = storage.get(HISTORY_KEY)
      return history && history.splice(0, 10) // 取前十条
    }
  }
}
</script>

<style lang="scss">
.sug-select-user {
  overflow: hidden;
  height: 100%;
  position: relative;
  .popup {
    .popup-panel {
      .popup-choose {
        display: none; // 隐藏 popup 的 titlebar
      }
    }
  }
  .search-history {
    position: absolute;
    width: 100%;
    top: 100px;
    bottom: 0;
    z-index: 0;
    font-size: 32px;
    .search-recommended {
      .recommended-title {
        height: 125px;
        line-height: 125px;
        padding: 0 30px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .search-recommended-title {
          font-family: DiDiSans-Pro-Medium;
          font-size: 36px;
          color: #282B33;
          font-weight: normal;
        }
      }
      .search-list {
        padding: 0 20px;
        display: flex;
        flex-wrap: wrap;
        .search-list-recommended-item {
          border: 1px solid #C2C4CC;
          margin: 10px 10px;
          border-radius: 8px;
          .rich-cell-text {
            font-family: DiDiSans-Pro-Regular;
            font-size: 28px;
            color: #595C66;
            font-weight: normal;
          }
        }
      }
    }
    .rich-cell {
      min-height: 68px;
      display: contents;
    }
    .search-list {
      padding: 0 20px;
      display: flex;
      flex-wrap: wrap;
      .search-list-history-item {
        border: 1px solid #C2C4CC;
        margin: 10px 10px;
        border-radius: 8px;
        .rich-cell-text {
          font-family: DiDiSans-Pro-Regular;
          font-size: 28px;
          color: #595C66;
          font-weight: normal;
        }
      }
    }
    .history-title {
      height: 125px;
      line-height: 125px;
      padding: 0 30px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .search-history-title {
        font-family: DiDiSans-Pro-Medium;
        font-size: 36px;
        color: #282B33;
        font-weight: normal;
      }
      i{
        font-size: 36px;
        color: #8D9099;
      }
    }
    .search-list-wrap {
      width: 100%;
      overflow: auto;
      .remove-btn {
        padding: 20px 0 20px 20px;
      }
    }
  }
  .search-bar {
    position: relative;
    align-items: center;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    padding: 20px;
    z-index: 1;
    height: 100px;
    top: var(--barheight);
    background: #FFF;
    // .rich-input {
    //   width: 100%;
    //   background-color: $color-col-line;
    //   color: $color-light-grey;
    //   &::placeholder {
    //     color: $color-light-grey;
    //   }
    // }
    .cancel-btn {
      padding: 10px;
      cursor: pointer;
      padding-right: 24px;
      font-size: $fontsize-large-xx;
      color: #000;
    }
    .search-input {
      // background: $color-col-line;
      // height: 80px;
      display: flex;
      flex: 1;
      align-items: center;
      .search-input-box {
        flex: 1;
        .richic-search {
          font-size: 37px;
          color: #666;
          padding: 0 13px;
        }
      }
      .rich-input-box-bottom {
        padding: 0;
      }
      .rich-input-wrapper .rich-input-field {
        background: #E9EAEE;
        border-radius: 0 8px 8px 0;
      }

      .rich-input-box {
        height: 72px;
        background: #e9eaee;
        border-radius: 8px;

        &::after {
          border-color: transparent !important;
        }

        .icon-v2-outline_search {
          width: 36px;
          height: 36px;
          font-size: 36px;
          margin: 0 13px;
          color: #666666;
        }

        input {
          outline: none;
          height: 72px;
          font-size: 28px;
          appearance: none;
           &::-webkit-input-placeholder {
             font-size: 28px;
             font-family: DiDiSans-Pro-Regular;
             color: #999999;
             letter-spacing: 0;
             line-height: 36px;
             font-weight: normal;
           }
        }

        &.rich-input-box_active {
          &::after {
            content: "";
            border-color: transparent;
          }
          border: none;
        }
      }
      .rich-input-box-prepend {
        margin: 0;
        .filter-button {
          padding: 0;
        }
        .title {
          width: 195px;
          font-family: PingFangSC-Regular;
          font-size: 28px;
          color: #595C66;
          font-weight: 400;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
  }
  .rich-loading-spinners {
    margin: 30px auto;
  }
  .search-result {
    .search-list-item {
      .rich-cell-title {
        text-align: left;
      }
    }
  }
  .search-scroll-wrap {
    position: absolute;
    top:  calc(var(--barheight) + 100px);
    bottom: 0;
    width: 100%;
    .search-list-inner-wrap {
      padding-bottom: 60px;
    }
  }
  .search-list {
    padding: 0 20px;
  }
}
</style>
